import { render } from "./edit_patient_details.vue?vue&type=template&id=e86834c4&scoped=true"
import script from "./edit_patient_details.vue?vue&type=script&lang=js"
export * from "./edit_patient_details.vue?vue&type=script&lang=js"

import "./edit_patient_details.vue?vue&type=style&index=0&id=e86834c4&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86834c4"]])

export default __exports__